import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import QueryString from "qs";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { ReqMethods, ghl } from "enums";
import env from "config";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
// import { AgencyContext } from '../../../context/Agency.context'

function GHL() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const code = new URLSearchParams(search).get("code");
  const type = new URLSearchParams(search).get("type");
  const AppServices = useAppServices();
  const [Error, setError] = useState("");

  const searchParams = new URLSearchParams(document.location.search);
  const agency = searchParams.get("state");
  // alert(agency);
  const associate = async (creds) => {
    const payload = {
      _id: agency,
      agency_ghl: {
        company_id: creds.companyId,
        access_token: creds.access_token,
        refresh_token: creds.refresh_token,
      },
    };

    const { response } = await AppServices.brand.update({ payload });

    if (!response) return setError("Something went wrong while integration, please try latter");
    // update(payload);
    return setError("agency SuccessFully connected");
    setTimeout(() => {
      // return navigate(-1);
    }, 2000);
  };

  // const getLocation = async (creds) => {
  //   const payload = {
  //     method: ReqMethods.GET,
  //     path: `${ghl.APIs.v2.location(creds.locationId)}`,
  //     key: creds.access_token,
  //     refresh_token: creds.refresh_token,
  //   }
  //   const { response } = await AppServices.services.ghl.call_service({ payload })

  //   if (!response) return setError('Something went wrong while integration, please try latter')

  //   return response && associate(response.data, creds)
  // }

  const getCreds = async () => {
    const payload = {
      method: ReqMethods.POST,
      path: ghl.APIs.oauth,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      payload: QueryString.stringify({
        client_id: env.GHL.CLIENT_ID,
        client_secret: env.GHL.CLIENT_SECRET,
        grant_type: "authorization_code",
        code,
        refresh_token: "",
      }),
    };
    //  
    const { response } = await AppServices.services.ghl.call_service({ payload });

    if (!response) return setError("Something went wrong while integration, please try latter");
    // if(location_id !== response.data.locationId) return setError('location ID mismatch')
     
    return response && associate(response.data);
  };

  const onLoad = () => {
    // getCreds();
  };

  useEffect(onLoad, []);

  return (
    <SoftBox>
      {!Error && <SoftBox>Integrating please wait...</SoftBox>}
      {Error && (
        <SoftBox>
          {Error}
          <SoftButton onClick={() => navigate(-2)}>Go Back</SoftButton>
        </SoftBox>
      )}
    </SoftBox>
  );
}

export default GHL;
